import React from "react";
import { connect } from "react-redux";
import history from "../../auth/history";
import moment from "moment";
import { selectedSender, setBeneSubDetails } from './../../redux/misc-data/misc-data.action';
import { store } from "../../redux/store";
class BenefisciarySubDetails extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			password: '',
			otpRef: '',
			message: ''
		}
	}

	componentDidMount() {
	}
	componentWillUnmount() {
	}






	render() {

		console.log(JSON.stringify(this.props.beneSubDetails));


		return (

			<div class="benereviewcard">


				<div class="row">
					<div class="col-12 col-md-4">
						<div class="benedtl">
							{/* <img src="images/sbi-bank.png" alt=""></img> */}
							<h4>{this.props.beneSubDetails != null && this.props.beneSubDetails.benefisciaryName}</h4>
							<p>{this.props.beneSubDetails != null && this.props.beneSubDetails.bankName}</p>
						</div>
					</div>

					<div class="col-12 col-sm-6 col-md-4">
						<div class="benedtl">
							<h5>Account Number</h5>
							<p>{this.props.beneSubDetails != null && this.props.beneSubDetails.accountNumber}</p>
						</div>
					</div>


					<div class="col-6 col-sm-3 col-md-2">
						<div class="benedtl">
							<h5>Mobile No.</h5>
							<p>{this.props.beneSubDetails != null && this.props.beneSubDetails.benefisciaryMobile}</p>
						</div>
					</div>

					<div class="col-6 col-sm-3 col-md-2">
						<div class="benedtl rtxt">
							<h5>IFSC Code</h5>
							<p>{this.props.beneSubDetails != null && this.props.beneSubDetails.ifscCode}</p>
						</div>
					</div>

					<div class="col-12"><hr /></div>


					<div class="col-12 col-md-4">
						<div class="sender-profile">
							<h5>Sender Name</h5>
							<p>{this.props.beneSubDetails != null && this.props.beneSubDetails.customerName}</p>
						</div>
					</div>

					<div class="col-6 col-md-4">
						<div class="sender-profile">

							<h5>{(this.props.beneSubDetails.govtIdType == 'AADHAAR_CARD' ||
								this.props.beneSubDetails.govtIdType == 'AADHAAR CARD') && 'Aadhaar Card'
							}</h5>
							<h5>{(this.props.beneSubDetails.govtIdType == 'BILL_ADDRESS_PROOF' ||
								this.props.beneSubDetails.govtIdType == 'BILL ADDRESS PROOF') && 'Voter Card'
							}</h5>
							<h5>{(this.props.beneSubDetails.govtIdType == 'DRIVERS_LICENSE' ||
								this.props.beneSubDetails.govtIdType == 'DRIVERS LICENSE') && 'Driving License'
							}</h5>
							<h5>{(this.props.beneSubDetails.govtIdType == 'PAN_CARD' ||
								this.props.beneSubDetails.govtIdType == 'PAN CARD') && 'Pan Card'
							}</h5>
							<h5>{(this.props.beneSubDetails.govtIdType == 'PASSPORT') && 'Passport'
							}</h5>


							<p>{this.props.beneSubDetails != null && this.props.beneSubDetails.govtIdValue}</p>
						</div>
					</div>
					{this.props.senderMobileShown == true &&
						<div class="col-6 col-md-4">
							<div class="sender-profile rtxt">

								<h5>Sender Mobile No.</h5>
								<p>{this.props.beneSubDetails != null && this.props.beneSubDetails.senderMobile}</p>
							</div>
						</div>
					}


					{this.props.beneCustomerId != '' &&
						<div class="col-12"><hr /></div>
					}


					{this.props.beneCustomerId != '' &&
						<div class="col-6 col-md-5">
							<div class="sender-profile">
								<h5>Reference ID</h5>
								<p>{this.props.beneCustomerId}</p>
							</div>
						</div>
					}

					{this.props.beneCustomerId != '' &&
						<div class="col-6 col-md-7">
							<div class="sender-profile stxt">
								<h5>Date & Time</h5>
								<p>{moment().format("DD-MM-YYYY HH:mm:ss")}</p>
							</div>
						</div>
					}



				</div>
			</div>

		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, customerId, benefisciaryRequest, addsenderRequest,
			agentInfo, ifscCode, selectSender, beneSubDetails, beneCustomerId } }
) => ({
	errorMessage, loginErrorMessage, phone, customerId,
	benefisciaryRequest, addsenderRequest, agentInfo, ifscCode, selectSender, beneSubDetails, beneCustomerId
});

export default connect(mapStateToProps, null)(BenefisciarySubDetails);
